var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"embed-container",class:{
        'text': _vm.module.view == 'content-wide',
        'wide': !_vm.module.view || _vm.module.view == 'default',
        'full': _vm.module.view == 'no-padding',
        'is-figma': _vm.isFigma
    }},[_c('div',{staticClass:"embed-wrapper",domProps:{"innerHTML":_vm._s(_vm.html)}}),_vm._v(" "),(_vm.module.showCaption && _vm.module.caption)?_c('figcaption',{staticClass:"f-small color-gray-0 caption-material",domProps:{"innerHTML":_vm._s(_vm.module.caption)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }